import { render, staticRenderFns } from "./imageupload.vue?vue&type=template&id=31a9b9ec&scoped=true&"
import script from "./imageupload.vue?vue&type=script&lang=js&"
export * from "./imageupload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a9b9ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31a9b9ec')) {
      api.createRecord('31a9b9ec', component.options)
    } else {
      api.reload('31a9b9ec', component.options)
    }
    module.hot.accept("./imageupload.vue?vue&type=template&id=31a9b9ec&scoped=true&", function () {
      api.rerender('31a9b9ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormGen/FormDesign/ItemConfig/imageupload.vue"
export default component.exports